module.exports = __webpack_public_path__ + "img/bn3.a451c76a.png";